import { callApiWithAuthorization } from "./CallApi";

export const sendEmail = async (email, templateId, properties) => {
    await callApiWithAuthorization("/api/v0/sendEmail", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            email: email,
            templateId: templateId,
            templateProperties: properties
        })
    });
};


export const sendUserAccountVerificationEmail = async (userId, loggedInUser) => {
    let link = process.env.REACT_APP_DESIGNER_URL + "/_VerifyAccount/" + userId + "/" + loggedInUser.localAccountId
    let properties = {
        userEmail: loggedInUser.username,
        url: link,
        subject: 'Complete your Codeless ONE sign up',
    }
    await sendEmail(loggedInUser.username, process.env.REACT_APP_SENDGRID_ACTIVATE_KEY, properties);
}